import React, { useCallback, useState } from 'react';
import { Grid, ConfigContext } from '../../base-ui/lib';
import { useNavigate } from 'react-router-dom';
import AssemblyGridToolbar from './AssemblyGridToolbar';
import EmptySearchState from '../../base-ui/Grid/components/EmptySearchState';

const EmptyStateComponent = () => <EmptySearchState />;

function AssemblyPage() {
    const { config } = React.useContext(ConfigContext);
    const navigate = useNavigate();
    const gridRef = React.useRef(null);

    const [filter, setFilter] = useState('');
    const [assemblyType, setAssemblyType] = useState('');
    const [edgeType, setEdgeType] = useState('');
    const [allData, setAllData] = useState([]);

    const renderToolbar = useCallback(() => (
        <AssemblyGridToolbar
            filter={filter}
            setFilter={setFilter}
            assemblyType={assemblyType}
            setAssemblyType={setAssemblyType}
            edgeType={edgeType}
            setEdgeType={setEdgeType}
            allData={allData}
            handleRefresh={() => gridRef.current?.onRefresh()}
            onAdd={null}
        />
    ), [filter, setFilter, assemblyType, setAssemblyType, edgeType, setEdgeType, allData]);

    const filterList = [
        { id: 'name', label: 'Name', dataType: 'string', defaultValue: '' },
        {
            id: 'assemblyTypeName',
            label: 'Assembly Type',
            dataType: 'string',
            defaultValue: '',
        },
        {
            id: 'edgeTypeName',
            label: 'Edge Type',
            dataType: 'string',
            defaultValue: '',
        },
    ];

    const headCells = [
        {
            field: 'name',
            headerName: 'Name',
            flex: 2,
        },
        {
            field: 'assemblyType.name',
            headerName: 'Assembly Type',
            valueGetter: (_, row) => row.assemblyType?.name || 'N/A',
            flex: 1.5,
        },
        {
            field: 'edgeType.name',
            headerName: 'Edge Type',
            valueGetter: (_, row) => row.edgeType?.name || 'N/A',
            flex: 1,
        },
        {
            field: 'price',
            headerName: 'Total Price',
            type: 'number',
            valueFormatter: (_, row) => {
                const price = row.materials?.reduce(
                    (total, material) => total + (material.price || 0),
                    0
                ) || 0;
                
                if (isNaN(price)) return '$0.00';
                return price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
            },
            flex: 0.8,
            sortable: false,
        },
    ];

    return (
        <Grid
            ref={gridRef}
            headCells={headCells}
            filterList={filterList}
            actionRowClick={({ row }) => {
                navigate(`/assembly/${row._id}`);
            }}
            pageSize={25}
            pageSizeOptions={[10, 25, 50]}
            searchEndpont={`${config.uri.base}/assembly`}
            hybridMode={true}
            initialPageSize={5000}
            toolbar={renderToolbar}
            showToolbar
            onDataLoad={setAllData}
            options={{ filter, assemblyType, edgeType }}
            customNoRowsOverlay={EmptyStateComponent}
        />
    );
}

export default AssemblyPage;